/* global google */

// TODO: Ne upisivati u JS pathove
const MapMarkerIconsRootDir = '/static/assets/img/maps/';

const MapMarkerIcons = {
  camp: {
    normal: {
      url: MapMarkerIconsRootDir + 'pin.png',
      size: new google.maps.Size(2 * 36, 2 * 46),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(17, 44),
      scaledSize: new google.maps.Size(36, 46),
    },

    hover: {
      url: MapMarkerIconsRootDir + 'pin_active.png',
      size: new google.maps.Size(2 * 36, 2 * 46),
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(17, 44),
      scaledSize: new google.maps.Size(36, 46),
    },
  },
};

export default MapMarkerIcons;



// WEBPACK FOOTER //
// ./src/js/maps/MapMarkerIcons.js